import React from 'react'
import { cn } from '@/lib/utils'

interface MarginOption {
  value: number
  label: string
  variant?: 'default' | 'negative'
}

interface MarginButtonGroupProps {
  onApply: (percentage: number) => void
  options?: MarginOption[]
  label?: string
  disabled?: boolean
}

const defaultOptions: MarginOption[] = [
  { value: 0, label: '= FIPE' },
  { value: 5, label: '+5%' },
  { value: 10, label: '+10%' },
  { value: 15, label: '+15%' },
  { value: 20, label: '+20%' },
  { value: -5, label: '-5%', variant: 'negative' },
  { value: -10, label: '-10%', variant: 'negative' },
]

export const MarginButtonGroup: React.FC<MarginButtonGroupProps> = ({
  onApply,
  options = defaultOptions,
  label = 'Calcular sobre FIPE:',
  disabled = false,
}) => {
  return (
    <div>
      {label && (
        <p className="text-xs font-medium text-muted-foreground mb-1.5">{label}</p>
      )}
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onApply(option.value)}
            disabled={disabled}
            className={cn(
              'px-2.5 py-1 text-xs font-medium border rounded-md transition-colors disabled:opacity-40 disabled:cursor-not-allowed',
              option.variant === 'negative'
                ? 'border-orange-200 text-orange-700 hover:bg-orange-50 dark:border-orange-800 dark:text-orange-400 dark:hover:bg-orange-900/20'
                : option.value === 0
                ? 'border-border text-muted-foreground hover:bg-surface'
                : 'border-emerald-200 text-emerald-700 hover:bg-emerald-50 dark:border-emerald-800 dark:text-emerald-400 dark:hover:bg-emerald-900/20',
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
